import { Head } from "@inertiajs/react"

/**
 * TEMPORARY CDN load — a deliberate, player-scoped exception to the
 * design manual's no-CDN-fonts rule while the jacket voices are auditioned.
 * The "Vinyl Covers" handoff type stack: Zilla Slab (titles, 600/700),
 * Source Serif 4 (body/signatures, 400/600 with the optical-size axis), and
 * Space Mono (labels/tags, 400/700). To self-host: add @font-face blocks to
 * styles/fonts.css and delete this component + its render in
 * RecordSleeveShell. Hanken Grotesk is already self-hosted (fonts.css) and
 * deliberately not requested here.
 */
export function JacketFonts() {
  return (
    <Head>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="anonymous"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Zilla+Slab:wght@600;700&family=Source+Serif+4:opsz,wght@8..60,400;8..60,600&family=Space+Mono:wght@400;700&display=swap"
      />
    </Head>
  )
}
